// @flow
import styled from 'styled-components';

export default styled.h2`
    font-size: '1.5rem';
    font-weight: ${({ slim }) => (slim ? 400 : 500)};
`;



// WEBPACK FOOTER //
// ./src/components/widgets/headings/h2/index.js